import React, { useState, useEffect, useContext } from "react";
import { DataContext } from "../context/DataContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { get_all_district_data } from "../controllers/dataController";

// Convert DD/MM/YYYY to YYYY-MM-DD for HTML date input
const convertDateFormat = (dateString) => {
  if (!dateString) return "";
  
  // Check if already in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return dateString;
  }
  
  // Convert DD/MM/YYYY to YYYY-MM-DD
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  }
  
  return dateString;
};

export const CustomFormInput = ({ field, formData, setFormData, currentStep }) => {
  const {
    getApplicationData,
    applicationData,
    setApplicationData,
    updateApplicationData,
    dataLoading,
    setDataError,
    universities,
    districts,
    get_all_district,
    get_all_university,
  } = useContext(DataContext);
  const [showPreview, setShowPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const {
    label: originalLabel,
    input_type: inputType,
    field_name: name,
    max_length,
    max_value,
    min_value,
    pattern,
    options,
    max_size_mb,
    error_message,
  } = field;

  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (name == "district" || name == "state") {
      get_all_district();
    }
    if (name === "ug_university_name" || name === "pg_university_name") {
      get_all_university();
    }
  }, [currentStep, name]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onChange(e); // update form state
    console.log("Districts data ", districts.length);
    if (inputValue.length > 0) {
      let results;
      if (name == "district" || name == "state") {
        if (districts.length > 0) {
          console.log(
            "field change ",
            districts.length,
            formData["district"],
            formData["state"]
          );
          if (name == "state") {
            const stateSearch = formData["state"].toLowerCase().trim();
            const uniqueStates = Array.from(
              new Set(districts.map((d) => d["State Name"]))
            );

            results = uniqueStates.filter((state) =>
              state.toLowerCase().includes(stateSearch)
            );
          } else {
            results = districts
              .filter((d) =>
                d["State Name"]
                  .toLowerCase()
                  .includes(formData["state"].toLowerCase())
              )
              .filter((d) =>
                d["District Name"]
                  .toLowerCase()
                  .includes(formData["district"].toLowerCase())
              );
          }
        }
      } else {
        if (universities.length > 0) {
          results = universities
            .filter((d) =>
              d["university"].toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 7);
        }
      }
      console.log("Searching results : ", results);
      setFilteredDistricts(results);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelect = (districtName, stateName) => {
    console.log("Selected dist", districtName, stateName);
    if (name == "district") {
      setFormData((prev) => ({
        ...prev,
        district: districtName,
        state: stateName,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: districtName,
      }));
    }

    setShowDropdown(false);
  };

  let required = field.required;
  // Use field.value from backend first, then formData (for date fields, field.value might be in DD/MM/YYYY format)
  let value = field.value !== null && field.value !== undefined && field.value !== "" 
    ? field.value 
    : (formData[name] || "");
  
  // Check if there's an existing file from backend or a newly selected file
  const hasExistingFile = inputType === "file" &&
    field.value !== null &&
    field.value !== "" &&
    field.value !== undefined;
  
  const hasNewFile = inputType === "file" && formData[name] instanceof File;
  
  const showPreviewBtn = hasExistingFile || hasNewFile;

  let label = originalLabel;
  // Only disable/readonly when status is "Completed", allow editing when "Selected"
  const disabled = applicationData.status === "Completed";
  const readOnly = disabled;

  const [error, setError] = useState("");

  // Clean up object URL when component unmounts or file changes
  useEffect(() => {
    return () => {
      if (previewUrl && previewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  function onChange(e) {
    let fieldValue = inputType === "file" ? e.target.files?.[0] : e.target.value;
    if (!fieldValue) {
      if (inputType === "file") {
        console.log("Selected File for:", name, fieldValue);
        setFormData((prev) => ({
          ...prev,
          [name]: fieldValue,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: fieldValue,
        }));
      }
      return;
    }

    if (name == "pan_card_number") {
      fieldValue = fieldValue.toUpperCase();
      console.log("capatilize ", fieldValue);
    }
    if (name == "email") {
      fieldValue = fieldValue.toLowerCase();
      console.log("capatilize ", fieldValue);
    }

    if (pattern && inputType !== "file") {
      const regex = new RegExp(pattern);

      if (!regex.test(fieldValue)) {
        console.log("Patteren error");
        setError(error_message || `Invalid format`);
      } else {
        console.log("Patteren no error");
        setError("");
      }
    }

    if (inputType === "file") {
      const file = e.target.files?.[0];
      console.log("Selected File for:", name, file);
      if (file) {
        // Revoke old preview URL if it exists
        if (previewUrl && previewUrl.startsWith('blob:')) {
          URL.revokeObjectURL(previewUrl);
        }
        // Create object URL for preview
        const objectUrl = URL.createObjectURL(file);
        setPreviewUrl(objectUrl);
        setFormData((prev) => ({
          ...prev,
          [name]: file,
        }));
      } else {
        // Clear preview URL if file is removed
        if (previewUrl && previewUrl.startsWith('blob:')) {
          URL.revokeObjectURL(previewUrl);
        }
        setPreviewUrl(null);
      }
    } else {
      console.log("Editing Field Name:", name, "Value:", fieldValue);
      setFormData((prev) => ({
        ...prev,
        [name]: fieldValue,
      }));
    }
  }

  // If file already uploaded, show uploaded status
  if (showPreviewBtn) {
    console.log("Show preview Button", field.value);

    console.log(field.value !== "", field.value !== null);
    required = false;

    value = null;
  }
  const isImageFile = (filename) => {
    if (!filename) return false;
    // Handle both string filenames and File objects
    const name = typeof filename === 'string' ? filename : filename.name;
    return /\.(jpe?g|png|gif|bmp|webp)$/i.test(name);
  };

  const getPreviewText = () => {
    // Custom preview text based on field name
    if (name === "aadhar_front") {
      return "Preview-Aadhar(Front)";
    } else if (name === "aadhar_back") {
      return "Preview-Aadhar(Back)";
    } else if (name === "pan_card") {
      return "Preview-PAN";
    }
    // Fallback to filename for other file fields
    if (hasNewFile && formData[name] instanceof File) {
      return `Preview - ${formData[name].name}`;
    }
    if (hasExistingFile && field.value) {
      return `Preview - ${field.value.split("/").at(-1) || ""}`;
    }
    return "Preview";
  };

  const getPreviewUrl = () => {
    if (hasNewFile && previewUrl) {
      return previewUrl;
    }
    if (hasExistingFile && field.value) {
      return `${process.env.REACT_APP_BASE_URL}/${field.value}?token=${localStorage.getItem("TOKEN")}`;
    }
    return null;
  };

  const handlePreviewClick = () => {
    setShowPreview(true);
  };

  return (
    <>
      {showPreview && getPreviewUrl() && isImageFile(hasNewFile ? formData[name] : field.value) && (
        <div
          className="image-preview-overlay"
          onClick={() => setShowPreview(false)}
        >
          <div className="image-preview-container">
            <img
              src={getPreviewUrl()}
              alt="Document image"
              className="image-preview-image"
            />
          </div>
        </div>
      )}

      <div className="custom-input-group">
        <div className="input-label-wrapper">
          <label className="input-label">
            {inputType == "file" && !showPreviewBtn && (
              <div className="image-preview-blank">|</div>
            )}
            {label} {required && <span className="required">*</span>}
          </label>
          {showPreviewBtn && (hasExistingFile || hasNewFile) && (
            <div className="preview-link-container">
              {isImageFile(hasNewFile ? formData[name] : field.value) ? (
                <div className="image-preview" onClick={handlePreviewClick}>
                  {getPreviewText()}
                </div>
              ) : (
                <a
                  href={getPreviewUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="image-preview"
                  download
                >
                  {getPreviewText()}
                </a>
              )}
            </div>
          )}
        </div>

        {inputType === "select" ? (
          <select
            key={name}
            name={name}
            value={value}
            required={required}
            disabled={disabled}
            readOnly={readOnly}
            onChange={onChange}
            className="input-field"
          >
            <option value="">Select {label}</option>
            {options.map((opt, idx) => (
              <option key={idx} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        ) : inputType === "year" ? (
          <DatePicker
            key={name}
            selected={value ? new Date(value, 0) : null}
            onChange={(date) =>
              onChange({ target: { name, value: date.getFullYear() } })
            }
            showYearPicker
            dateFormat="yyyy"
            className="input-field"
            disabled={disabled}
            readOnly={readOnly}
            minDate={new Date(2000, 0, 1)}
            maxDate={new Date(new Date().getFullYear(), 11, 31)}
          />
        ) : inputType === "date" ? (
          <input
            key={name}
            type="date"
            name={name}
            className="input-field"
            value={value ? convertDateFormat(value) : ""}
            required={required}
            disabled={disabled}
            readOnly={readOnly}
            onChange={onChange}
          />
        ) : name == "district" ||
          name == "state" ||
          name == "ug_university_name" ||
          name == "pg_university_name" ? (
          <>
            <input
              key={name}
              type="text"
              name={name}
              value={value}
              required={required}
              disabled={disabled}
              readOnly={readOnly}
              onChange={handleInputChange}
              className="input-field"
              autoComplete="off"
            />
            {showDropdown && filteredDistricts.length > 0 && (
              <ul className="autocomplete-dropdown">
                {filteredDistricts.map((d, i) =>
                  name == "district" ? (
                    <li
                      key={i}
                      onClick={() =>
                        handleSelect(d["District Name"], d["State Name"])
                      }
                    >
                      {d["District Name"]}
                    </li>
                  ) : name == "state" ? (
                    <li key={i} onClick={() => handleSelect(d)}>
                      {d}
                    </li>
                  ) : (
                    <li key={i} onClick={() => handleSelect(d["university"])}>
                      {d["university"]}
                    </li>
                  )
                )}
              </ul>
            )}
          </>
        ) : (
          <input
            key={name}
            type={inputType}
            name={name}
            className="input-field"
            {...(inputType !== "file" ? { value: value || "" } : {})}
            required={required}
            disabled={disabled}
            readOnly={readOnly}
            onChange={onChange}
            maxLength={max_length}
          />
        )}

        {error && <span className="error-text">{error}</span>}
      </div>
    </>
  );
};
